module.exports = __webpack_public_path__ + "img/tw.587d478a.svg";